export const BACKEND_API_BASE_URL = (() => {

  if (typeof window === "undefined") {
    return "https://voiceboxapi.nspl.cloud/api";
  }

  const { hostname } = window.location;

  if (hostname === "localhost") {
    return "http://localhost:3900/api";
  }

  if (hostname === "voice.expressivr.com") {
    return "https://api-voice.expressivr.com/api";
  }

  if (hostname === "voiz.nspl.cloud") {
    return "https://voizapi.nspl.cloud/api";
  }

  if (hostname === "voicebox.nspl.cloud") {
    return "https://voiceboxapi.nspl.cloud/api";
  }

  return "https://voiceboxapi.nspl.cloud/api";
})();


// Proxy (used by API Builder to bypass CORS while testing URLs)
export const PROXY_URL = "https://voiceboxapi.nspl.cloud/proxypass";

export const USER_STATUS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const PROMPT_STATUS = {
  APPROVED: 1,
  REJECT: 2,
  PENDING: 0,
}

export const USER_CREDITS_ACTION = {
  ADD: "addition",
  DEDUCT: "deduction"
}


export const LICENCE_LABEL = {
  channel: "Channel",
  company: "Company",
  live_agent: "Live Agent",
  role_ccagent: "Total Agent",
  role_ccadmin: "Call Centers",
};

export const TTS_CREDITS_ACTION = {
  ADDITION: "TTS_ADDITION",
  DEDUCTION: "TTS_DEDUCTION"
}

export const USER_STATUS_LABEL = ["Active", "Inactive"];

export const USER_ROLES = {
  RESELLER: "role_reseller",
  SUPERADMIN: "role_sadmin",
  COMPANY_ADMIN: "role_cadmin",
  CALL_CENTRE_ADMIN: "role_ccadmin",
  CALL_CENTRE_TEAM_LEAD: "role_ccteamlead",
  CALL_CENTRE_AGENT: "role_ccagent",
  CALL_CENTRE: "role_call_centre",
  SUB_SUPERADMIN: "role_sub_superadmin"
};

export const USER_ROLES_MAP = {
  [USER_ROLES.RESELLER]: "Reseller",
  [USER_ROLES.SUPERADMIN]: "Superadmin",
  [USER_ROLES.COMPANY_ADMIN]: "Company user",
  [USER_ROLES.CALL_CENTRE_ADMIN]: "Call Centre Admin User",
  [USER_ROLES.CALL_CENTRE_TEAM_LEAD]: "Call Centre Admin Team Lead",
  [USER_ROLES.CALL_CENTRE_AGENT]: "Call Centre Admin Agent",
  [USER_ROLES.CALL_CENTRE]: "Call Centre",
  [USER_ROLES.SUB_SUPERADMIN]: "Sub Superadmin"
};

export const USER_ROLES_MAP_PROFILE = {
  [USER_ROLES.RESELLER]: "Reseller",
  [USER_ROLES.SUPERADMIN]: "Superadmin",
  [USER_ROLES.COMPANY_ADMIN]: "Company",
  [USER_ROLES.CALL_CENTRE_ADMIN]: "Call Centre",
  [USER_ROLES.CALL_CENTRE_TEAM_LEAD]: "Team Lead",
  [USER_ROLES.CALL_CENTRE_AGENT]: "Agent",
  [USER_ROLES.CALL_CENTRE]: "Call Centre",
  [USER_ROLES.SUB_SUPERADMIN]: "Sub Superadmin"
};

export const PERMISSION_TYPES = {
  CREATE: "permission_create",
  READ: "permission_read",
  UPDATE: "permission_update",
  DELETE: "permission_delete",
};

export const ROUTES = {
  LOGIN: "auth/sign-in",
  DASHBOARD: "dashboard",
  SWITCH_ACCOUNT_LOADER: "/switch-account-loader",
  USERS: {
    EDIT: "users/:id",
    CREATE: "users/create",
    LIST: "users",
    RESELLERALLOCATE: 'allocate/:id/:currentId/:role',
    RESET_PASSWORD: "users/reset/:id"
  },
  COMPANIES: {
    LIST: "companies",
    EDIT: "companies/:id",
    CREATE: "companies/create",
  },
  CALL_CENTRES: {
    LIST: "call-centres",
    CREATE: "call-centres/create",
    EDIT: "call-centres/:id",
    USERS: {
      LIST: "call-centres/:id/users",
      CREATE: "call-centres/:id/users/create",
      EDIT: "call-centres/:id/users/:uid",
    },
  },
  TRUNKS: {
    EDIT: "trunks/:id",
    CREATE: "trunks/create",
    LIST: "trunks",
    DELETE: "trunks/:id",
  },
  NUMBERS: {
    EDIT: "numbers/:id",
    CREATE: "numbers/create",
    LIST: "numbers",
    DELETE: "numbers/:id",
    NUMBER_FILE_LIST: 'number-filelist/',
    NUMBER_FILE_DELETE: 'number-filelist/delete',
    STATUS_CHANGE_ACTION: 'number-status-change/',
    DID_MAPPING: 'numbers/did-mapping',
    ALLOCATED_NUMBERS: 'numbers/allocated/',
    DID_HISTORY: 'numbers/did-history/'

  },
  VOICE_PLAN: {
    CREATE: "voice-plan/create",
    LIST: "voice-plan",
  },

  FLASH_MESSAGE: {
    CREATE: "flash-message/create",
    LIST: "flash-message",
  },

  REALTIME: {
    LIST: "realtime",
  },


  REMARKS: {
    LIST: "remark-status-list",
    EDIT: "remark-status-edit/:id",
    ADD: "remark-status-add",
    REMARKS: 'remarks'
  },

  AGENT_ANNOUNCEMENT: {
    LIST: "agent-announcements",
    CREATE: "agent-announcements/create",
    EDIT: "agent-announcements/edit/:id",
    DELETE: "agent-announcements/delete",
  },

  AGENT_IDLE_STATS: {
    LIST: "agent-idle-stats",
  },

  MANAGE_GROUPS: {
    CREATE: "create-group",
    GROUP_LIST: "group-list",
    BULK_ADD: "group-bulk-add",
    BULK_DELETE: "group-bulk-delete"
  },

  MANAGE_LOCATIONS: {
    CREATE: "create-location",
    LOCATION_LIST: "location-list",
    BULK_ADD: "location-bulk-add",
    BULK_DELETE: "location-bulk-delete"
  },

  MANAGE_DIALERS: {
    CREATE: "create-dialer",
    EDIT: "create-dialer/:id",
    DIALER_LISTING: "dialer-list"
  },

  DESPOSITION: {
    ADD: "desposition-add"
  },

  DISPOSITION_FORMS: {
    LIST: "disposition-forms",
    CREATE: "disposition-forms/create",
    EDIT: "disposition-forms/edit/:id",
  },

  IVR: {
    EDIT: "call-centres/:cid/ivr/:id",
    CREATE: "call-centres/:cid/ivr/create",
    LIST: "call-centres/:cid/ivr",
    DELETE: "call-centres/:cid/ivr/:id",
    VIEW: "call-centres/:cid/ivr/view",
    ADD_VOICE: "call-centres/add-voice",
    VIEW_VOICE: "call-centres/view-voice",
    VIEW_TTS: "call-centres/view-tts",
    INBOUND_CALLS: 'inbound-calls/:cid',
    INCOMING_SUMMARY: "call-centres/incoming-summary",
    UPDATE_INBOUND_CALLS: 'update-inbound-calls/:cid',
    DOWNLOAD_REPORT: "call-centres/download-report",
    VIEW_DETAIL: "/did-report/:did/:startDate/:endDate"
  },
  DATA_CENTER: {
    EDIT: "data-center/:id",
    CREATE: "data-center/create",
    LIST: "data-center",
    DELETE: "data-center",
  },
  SERVER_MANAGEMENT: {
    EDIT: "server-management/:id",
    CREATE: "server-management/create",
    LIST: "server-management",
    DELETE: "server-management",
  },
  MODULE: {
    EDIT: "module/:id",
    CREATE: "module/create",
    LIST: "module",
    DELETE: "module/:id",
  },
  ACL_SETTING: {
    CREATE: "acl-settings/create",
    LIST: "acl-settings",
    EDIT: "acl-settings/:id",
    DELETE: "acl-settings/:id"
  },
  JOURNEY_OPERATION: {
    LIST: "journey-operation",
  },
  MANAGE_AGENTS: {
    AGENTS: "agents",
    CREATE_AGENT: "create-agent",
    CREATE_AGENT_GROUP: "create-agent-group",
    AGENT_GROUP_LIST: "agent-group-list",
    EXTENSION: "extension",
    CREATE_EXTENSION: "create-extension",
    EDIT_EXTENSION: "edit-extension/:id",
    GROUP_SETTINGS: "group-settings/:id",
    EDIT_AGENT: "agents/edit-agent/:id",
    AGENT_FILE_LIST: "agent-filelist/"

  },
  MANAGE_QUEUES: {
    CREATE: "create-queue",
    QUEUES: "queus"
  },
  VOICE_LIBRARY: {
    MANAGE_PROMPTS: "manage-prompts",
    VIEW_VOICE_FILES: "view-voice-files",
  },
  CREDIT_HISTORY: "credit-history",
  CREDIT_SUMMARY: "credit-summary",
  CAMPAIGNS: {
    LIST: "campaigns",
    CREATE: "create-campaign",
    DETAIL: "campaigns-detail/:id",
    DUPLICATE: "create-campaign/:duplicate_camp_id",
  },
  BREAKS: {
    LIST: "breaks",
    CREATE: "create-break",
    UPDATE: "breaks/:id"
  },
  WEBHOOK: {
    LIST: "webhook",
    CREATE: "create-webhook",
    UPDATE: "webhook/:id"
  },
  SMSWEBHOOK: {
    LIST: "sms-webhook",
    CREATE: "create-sms-webhook",
    UPDATE: "sms-webhook/:id"
  },
  MANAGE_WEBHOOK: {
    LIST: "manage-webhook",
    CREATE: "manage-webhook/create",
    EDIT: "manage-webhook/create/:id"
  },
  PROFILE: "profile",
  CONTACTGROUP: {
    LIST: "contact-group",
    CREATE: "contact-group/:id/create-contact",
    UPDATE: "contact-group/:id",
    IMPORT_MEMBERS: "contact-group/:id/import-members",
    ALL_CONTACTS: "all-contacts",
    CREATE_ALL_CONTACTS: "create-all-contacts",
  },
  TTS: {
    CREATE: "create-tts",
    LIST: "tts-list"
  },
  TTSPLANS: {
    CREATE: "create-tts-plans",
    LIST: "tts-plan-list"
  },
  LICENCE_HISTORY: {
    LIST: "licence-history-list"
  },
};

export const TRUNK_AUTH_TYPE_REGISTRATION = 1;
export const TRUNK_AUTH_TYPE_IP = 2;
export const TRUNK_AUTH_TYPES = [
  { label: "IP", value: TRUNK_AUTH_TYPE_IP },
  { label: "Registration", value: TRUNK_AUTH_TYPE_REGISTRATION },
];

export const OPERATOR_TYPES = [
  { label: "Airtel", value: 1 },
  { label: "Jio", value: 2 },
];

export const CONTENT_STATUS = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
];

export const NUMBERS_FORMAT_INDIVIDUAL = "INDIVIDUAL";
export const NUMBERS_FORMAT_FILE = "FILE";
export const NUMBERS_FORMAT_TYPES = [
  { label: "INDIVIDUAL", value: NUMBERS_FORMAT_INDIVIDUAL },
  { label: "FILE", value: NUMBERS_FORMAT_FILE },
];

export const NUMBERS_TYPES_DID = "DID";
export const NUMBERS_TYPES_VMN = "VMN";
export const NUMBERS_TYPES_TOLFREE = "TOLL FREE";
export const NUMBERS_TYPES = [
  { label: "DID", value: NUMBERS_TYPES_DID },
  { label: "VMN", value: NUMBERS_TYPES_VMN },
  { label: "TOLL FREE", value: NUMBERS_TYPES_TOLFREE },
]
export const BULK_UPDATE_DID = ['DID', 'Category', 'Currency', 'Country Code', 'State Code', 'Cost', 'Operator', 'Status', "TrunkId"];
export const BULK_UPDATE_OTHERS = ['DID', 'Currency', 'Country Code', 'Operator', 'Status', "TrunkId"];

export const UPLOAD_NUMBER_DID = ['Country Code', 'State Code', 'DID', 'Cost', 'Operator'];
export const SAMPLE_DATA_DID = [{ 'Country Code': 'IN', 'State Code': "HR", 'DID': '9991066739', 'Cost': '100', 'Operator': 'JIO' }];
export const SAMPLE_DATA_DID_UPDATE = [{ 'DID': '9991066739', 'Category': "Free", 'Currency': 'INR', 'Country Code': 'IN', 'State Code': "HR", 'Cost': '0', 'Operator': 'JIO', 'Status': "1", "TrunkId": "1" }];

export const UPLOAD_NUMBER_OTHERS = ['Country Code', 'DID', 'Operator'];
export const SAMPLE_DATA_OTHERS = [{ 'Country Code': 'IN', 'DID': '9991066739', 'Operator': 'JIO' }];
export const SAMPLE_DATA_OTHERS_UPDATE = [{ 'DID': '9991066739', 'Currency': 'INR', 'Country Code': 'IN', 'State Code': "HR", 'Operator': 'JIO', 'Status': "1", "TrunkId": "1" }];

export const ASSIGN_DID_VMN = ['DID', 'STATUS', 'VMN'];
export const ASSIGN_DID_TOLLFREE = ['DID', 'STATUS', 'TOLL FREE'];
export const UPLOAD_CONTACT_GROUP_MEMBERS = ['First Name(Required)', 'Last Name(Required)', 'State(Required)', 'City(Required)', 'Country(Required)', 'Company(Required)', 'Street(Required)', 'Primary Number(Required)', 'Alternate Number 1(Optional)', 'Alternate Number 2(Optional)'];
export const UPLOAD_CONTACT_GROUP_MEMBERS_DATA = [{ 'First Name(Required)': 'John', 'Last Name(Required)': 'Smith', 'City(Required)': 'Denmark', 'Country(Required)': "Brazil", 'Street(Required)': 'Corcovado Mountain', 'Primary Number(Required)': "1234567890", "Alternate Number 1(Optional)": "1234567891", "Alternate Number 2(Optional)": "1234567892", 'State(Required)': "CVE", 'Company(Required)': "Redeemers" }];



export const NUBMERS_STATUS_LABEL = ['Available', 'Blocked', 'Reserved', 'Archived', 'Terminated', 'Demo', 'Live', 'Delete', 'Pending', 'Reject']
export const API_DID_NUMBERS = 'numbers/did';


export const API_NUMBER_STATUS = 'numbers/number-status';


export const DATA_CENTER_DOMESTIC_TYPE = 0;
export const DATA_CENTER_INTERNATIONAL = 1;
export const DATA_CENTER_TYPES = [
  { label: "Domestic", value: DATA_CENTER_DOMESTIC_TYPE },
  { label: "International", value: DATA_CENTER_INTERNATIONAL },
];
export const DOMESTIC_COUNTRY = { label: "IN", value: "India" };

export const SERVER_MANAGEMENT_DOMESTIC_TYPE = 0;
export const SERVER_MANAGEMENT_INTERNATIONAL = 1;
export const SERVER_TYPES = [
  { label: "Domestic", value: SERVER_MANAGEMENT_DOMESTIC_TYPE },
  { label: "International", value: SERVER_MANAGEMENT_INTERNATIONAL },
];

export const PULSE_DURATION = [
  { label: "1 Sec", value: 1 },
  { label: "15 Sec", value: 15 },
  { label: "30 Sec", value: 30 },
  { label: "60 Sec", value: 60 },
];

export const PLAN_TYPE = [
  { label: "INBOUND", value: 'INBOUND' },
  { label: "OUTBOUND", value: 'OUTBOUND' },
  { label: "MISSED", value: 'MISSED' },
];

export const STATUS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

export const USERS_ROLE = {
  role_sadmin: "Super Admin",
  role_reseller: "Reseller",
  role_cadmin: "Company User",
  role_ccadmin: "Callcentre Admin",
  role_ccteamlead: "Callcenter Team Lead",
  role_ccagent: "Callcentre Agent",
  role_sub_superadmin: "Sub SuperAdmin"
};

export const IVR_LABELS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'];
export const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const CALL_CONNECT = {
  WEBSOCKET_HOST: "rtc.nspl.cloud",
  WEBSOCKET_PORT: 443,
  SIP_PORT: 443
}

export const UPLOAD_BULK_AGENT_CREATE = ['Agent Name', 'Agent Number', 'Email ID', 'Extension ID', 'Username', 'Password', 'Access', 'Type', 'Description'];
export const UPLOAD_BULK_AGENT_CREATE_REQUIREMENTS = ['Required', 'Required', 'Required', 'Optional', 'Required', 'Required', 'Required', 'Required', 'Optional'];
export const UPLOAD_BULK_AGENT_CREATE_SAMPLE_DATE = [{ 'Agent Name': "Agent_Name", 'Agent Number': "1234567890", 'Email ID': "agent@mymail.com", 'Extension ID': "1", 'Username': "My_Agent_Username", 'Password': "AgnPass@123", 'Access': "Regular", 'Type': "Mobile", 'Description': "My_Agent_Description" }];


export const RANDOM_CAPTCHA_VALUE = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHJKLMNOPQRSTUVWXYZ"
export const MODULE_ACL = {
  USERS: 'Users',
  BREAKS: 'Breaks',
  CALL_CENTRE: 'Call Centres List',
  COMPANY: 'Company List',
  CONTACT_GROUP: 'Contact Group',
  DISPOSITION_FORMS: 'Disposition Forms',
  DATA_CENTRE: 'Data Center',
  IVR: 'IVR',
  EXTENSION: 'Extension',
  GROUPS: 'Groups',
  AGENTS: 'Agents',
  CALL_GROUP: 'Call Group',
  PBX_MANAGEMENT: 'PBX Management',
  GATEWAY_MANAGEMENT: 'Gateway Management',
  TRUNKS: 'Trunks',
  LOCATIONS: 'Locations',
  WEBHOOK: 'Webhook',
  MODULE_LIST: 'Module List',
  ACL_SETTING_LIST: 'ACL Setting List',
  NUMBERS: 'Numbers',
  REMARKS_STATUS: 'Remarks Status',
  AGENT_ANNOUNCEMENT: 'Agent Announcement',
  VOICE_LIBRARY: 'Voice Library',
  SMS_WEBHOOK: 'SMS Webhook',
  TTS_PLANS: 'TTS Plans',
  TTS: 'TTS',
  MANAGE_PROMPTS: 'Manage Prompts',
  ACTIVITY_LIST: 'Activity List',
  AGENT_FILE_LIST: 'Agent File List',
  VOICE_PLANS: 'Voice Plans',
  FLASH_MESSAGE: 'Flash Message',
  CAMPAIGNS: 'Campaigns',
  CREDIT_HISTORY: 'Credit History'
}

export const DTMF_KEYS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "#"];
export const ACTION_COLORS = {
  answer: "green",
  gather: "purple",
  hangup: "red",
  play: "#007bff",
  transfer: "orange",
  record: "#20c997"
};
export const IVR_SETTING_ORDER = ["answer", "play", "gather", "record", "hangup",]

export const FLASH_MESSAGE_ACTION = ["Add", "Edit", "List", "Delete"]
export const FLASH_MESSAGE_TYPE = ["Flash Message", "Note"]

export const FLASH_MESSAGE_ACTION_OBJECT = {
  ADD: 'Add',
  EDIT: 'Edit',
  LIST: "List",
  DELETE: 'Delete'
}

export const HANGUP_CAUSES = [
  {id: 0, description: 'Cause not defined'},
  {id: 1, description: 'Unallocated (unassigned) number'},
  {id: 2, description: 'No route to specified transmit network'},
  {id: 3, description: 'No route to destination'},
  {id: 5, description: ' Misdialled trunk prefix (national use)'},
  {id: 6, description: 'Channel unacceptable'},
  {id: 7, description: 'Call awarded and being delivered in an established channel'},
  {id: 8, description: 'Preemption'},
  {id: 14, description: 'QoR: ported number'},
  {id: 16, description: 'Normal Clearing'},
  {id: 17, description: 'User busy'},
  {id: 18, description: 'No user responding'},
  {id: 19, description: 'No answer from user (user alerted)'},
  {id: 20, description: 'Subscriber absent'},
  {id: 21, description: 'Call Rejected'},
  {id: 22, description: 'Number changed'},
  {id: 23, description: 'Redirected to new destination'},
  {id: 26, description: 'Non-selected user clearing'},
  {id: 27, description: 'Destination out of order'},
  {id: 28, description: 'Invalid number format'},
  {id: 29, description: ' Facility rejected'},
  {id: 30, description: 'Response to STATUS ENQUIRY'},
  {id: 31, description: 'Normal, unspecified'},
  {id: 34, description: 'No circuit/channel available'},
  {id: 38, description: 'Network out of order'},
  {id: 41, description: 'Temporary failure'},
  {id: 42, description: 'Switching equipment congestion'},
  {id: 43, description: 'Access information discarded'},
  {id: 44, description: 'Requested circuit/channel not available'},
  {id: 50, description: 'Requested facility not subscribed'},
  {id: 52, description: 'Outgoing call barred'},
  {id: 54, description: 'Incoming call barred'},
  {id: 57, description: 'Bearer capability not authorized'},
  {id: 58, description: 'Bearer capability not presently available'},
  {id: 65, description: 'Bearer capability not implemented'},
  {id: 66, description: 'Channel type not implemented'},
  {id: 69, description: 'Requested facility not implemented'},
  {id: 81, description: 'Invalid call reference value'},
  {id: 88, description: 'Incompatible destination'},
  {id: 95, description: 'Invalid message unspecified'},
  {id: 96, description: 'Mandatory information element is missing	'},
  {id: 97, description: 'Message type non-existent or not implemented'},
  {id: 98, description: 'Message not compatible with call state or message type non-existent or not implemented'},
  {id: 99, description: 'nformation element nonexistent or not implemented'},
  {id: 100, description: 'Invalid information element contents'},
  {id: 101, description: 'Message not compatible with call state'},
  {id: 102, description: 'Recover on timer expiry'},
  {id: 103, description: 'Mandatory IE length error'},
  {id: 111, description: 'Protocol error, unspecified'},
  {id: 127, description: 'Interworking, unspecified'}
];